import { PipeTransform, Pipe } from "@angular/core";
import { ChannelTemplate } from "../../../../domain/channel-template";
import { ChannelTemplateCategory } from "../../../../domain/channel-template-category";

@Pipe({
  name: "filterByCategory",
})
export class ChannelTemplatesCategoryFilter implements PipeTransform {
  transform(
    templates: Array<ChannelTemplate>,
    category: ChannelTemplateCategory,
  ) {
    if (!category) return templates;

    return templates.filter((template) =>
      template.categories.find((cat) => cat.id == category.id),
    );
  }
}

@Pipe({
  name: "filterByTitle",
})
export class ChannelTemplatesSearchFilter implements PipeTransform {
  transform(templates: Array<ChannelTemplate>, searchTerm: string) {
    if (!searchTerm || searchTerm == "" || searchTerm == " ") return templates;

    return templates.filter((template) =>
      template.title
        .trim()
        .toLocaleLowerCase()
        .includes(searchTerm.toLocaleLowerCase().trim()),
    );
  }
}
